import types from '../types'
import api from '../../api'
import router from '../../router'

const state = {
  userInfo: {},
  isLogin: '',
  hasIdentify: false,
  proton: 0,
  grayscaleTest: false,
  offsetServerTime: 0
}

const getters = {
  userInfo: state => state.userInfo,
  proton: state => state.proton,
  grayscaleTest: state => state.grayscaleTest
}

const mutations = {
  [types.USER_INFO] (state, userInfo) {
    state.userInfo = userInfo
    if (userInfo && userInfo.code === 1) {
      window.zhuge.identify(userInfo.user_id, {
        /* eslint-disable */
        '角色': userInfo.roleText || '<null>',
        '性别': userInfo.gender ? userInfo.genderText : '<null>',
        '省份': userInfo.province || '<null>',
        '学校': userInfo.school || '<null>',
        '毕业时间': userInfo.graduation_year || '<null>'
        /* eslint-enable */
      })
      window.sensors.login(userInfo.user_id)
      window.sensors.setProfile({
        /* eslint-disable */
        'JiaoSe': userInfo.roleText || '<null>',
        'XingBie': userInfo.gender && userInfo.genderText ? userInfo.genderText : '<null>',
        'ShengFen': (userInfo.province + '') || '<null>',
        'XueXiao': (userInfo.school + '')|| '<null>',
        'BiYeShiJian': userInfo.graduation_year || '<null>'
        /* eslint-enable */
      })
      state.hasIdentify = true
      state.isLogin = true
      state.proton = userInfo.proton
      state.offsetServerTime = userInfo.server_time * 1000 - (new Date().getTime())
    } else {
      state.hasIdentify = false
      state.isLogin = false
    }
  },
  [types.USER_LOGOUT] (state) {
    state.isLogin = false
    if (router.app._route.name !== 'learningSituation') {
      router.push({ path: '/' })
    }
  },
  [types.UPDATE_PROTON] (state, data) {
    state.proton = data
  }
}

const actions = {
  getUserInfo ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.getUserInfo().then(res => {
        if (res.data && res.data.code === 1) {
          dispatch('getSocketList')
          dispatch('getCartCount')
          commit(types.USER_INFO, res.data || {})
        } else {
          commit(types.USER_INFO, {})
        }
        resolve(res)
      }, _ => {
        commit(types.USER_INFO, {})
        reject(_)
      })
    })
  },
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      api.logout().then(res => {
        commit(types.USER_LOGOUT)
        resolve(res)
      })
    })
  },
  updateProton ({ commit }, data) {
    commit(types.UPDATE_PROTON, data)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
